"use client";

import dynamic from "next/dynamic";

export const VoiceCloningWrapper = dynamic(() => import("./VoiceCloning").then(mod => mod.VoiceCloning));
